
export class DatosGrafico {
  Mes: number;
  Anio: number;
  Estado: number;
  Cantidad: number;
}
